import { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/apiClient";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PartyPopper, BookOpen, Users, ClipboardCheck } from "lucide-react";

const WELCOME_ROLES = ["lider", "supervisor"];

export function WelcomeDialog() {
  const { user, setUser } = useAuth();
  const [open, setOpen] = useState(false);

  const eligible = user && !user.is_admin && user.status === "aprovado" &&
    !user.welcomed && WELCOME_ROLES.includes(user.role);

  useEffect(() => { if (eligible) setOpen(true); }, [eligible]);

  const dismiss = async () => {
    setOpen(false);
    try {
      await api.post("/auth/welcomed");
      setUser({ ...user, welcomed: true });
    } catch { /* silencioso */ }
  };

  if (!eligible) return null;

  const firstName = (user.name || "").split(" ")[0];

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) dismiss(); }}>
      <DialogContent className="sm:max-w-md" data-testid="welcome-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-2xl">
            <PartyPopper className="h-6 w-6 text-accent" /> Bem-vindo(a), {firstName}!
          </DialogTitle>
          <DialogDescription>Seu acesso de liderança foi liberado na plataforma.</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Seu cadastro foi <strong className="text-foreground">aprovado</strong>! Que alegria ter você na liderança
          dos Pequenos Grupos de Discipulado da <strong className="text-foreground">Aprisco Church — Zona Norte</strong>.
        </p>
        <div className="mt-2 space-y-3 text-sm">
          <div className="flex items-start gap-3"><Users className="h-5 w-5 text-primary mt-0.5 shrink-0" /> <span>Gerencie seu grupo e acompanhe seus membros.</span></div>
          <div className="flex items-start gap-3"><ClipboardCheck className="h-5 w-5 text-primary mt-0.5 shrink-0" /> <span>Registre a frequência semanal dos encontros.</span></div>
          <div className="flex items-start gap-3"><BookOpen className="h-5 w-5 text-primary mt-0.5 shrink-0" /> <span>Acesse os Estudos do Mês e a Escola de Liderança.</span></div>
        </div>
        <Button onClick={dismiss} className="mt-4 w-full" data-testid="welcome-dismiss-button">Vamos começar</Button>
      </DialogContent>
    </Dialog>
  );
}
